namespace $.$$ {
	export class $shm_hitalama_map_widget_float_file extends $.$shm_hitalama_map_widget_float_file {
		
		name() {
			return this.widget().title() || this.widget().File()?.remote()?.title() || ''
		}

		ext() {
			return this.name().split('.').at(-1) ?? ''
		}

		file_size() {
			return $mol_si_short( this.widget().File()?.remote()?.size() ?? 0, 'B' )
		}

		contextmenu_unpack() {
			return [
				... this.contextmenu_for()[ this.ext() ] ?? [],
			]
		}

		is_audio() {
			return [ 'ogg', 'mp3', 'webm' ].includes( this.ext().toLowerCase() )
		}

		controls(): readonly ( any )[] {
			return this.is_audio() ? this.controls_audio() : super.controls()
		}

		@ $mol_mem
		audio_uri() {
			if( !this.is_audio() ) return ''

			const blob = this.widget().File()?.remote()?.blob()
			if( !blob ) return ''

			return URL.createObjectURL( blob )
		}

		override destructor() {
			const uri = $mol_wire_probe( ()=> this.audio_uri() )
			if( uri ) URL.revokeObjectURL( uri )

			super.destructor()
		}

		file_name() {
			return this.name()
		}

		@ $mol_mem
		tg_send_process() {
			const file = this.widget().File()?.remote()
			if( !file ) return null

			return this.$.$shm_hitalama_process.last( file, file.tg_send_file ) ?? null
		}

		tg_send_status() {
			const file = this.widget().File()?.remote()
			if( file?.Tg_file_id()?.val() ) return 'Загружено в tg'

			const process = this.tg_send_process()
			if( !process ) return ''

			const data = process.data()
			if( data.status === 'running' ) return 'Загрузка в tg...'
			if( data.status === 'done' ) return 'Загружено в tg'
			if( data.status === 'failed' ) return 'Ошибка загрузки в tg: ' + this.$.$mol_error_message( data.error )
			if( data.status === 'superseded' ) return 'Загрузка в tg отменена'

			return ''
		}

		tg_send_status_visible() {
			return this.tg_send_status() ? super.tg_send_status_visible() : []
		}

		tg_send_status_color() {
			const file = this.widget().File()?.remote()
			if( file?.Tg_file_id()?.val() ) return `${ $shm_theme.success }`
			const status = this.tg_send_process()?.data().status
			if( status === 'running' ) return `${ $shm_theme.active }`
			if( status === 'done' ) return `${ $shm_theme.success }`
			if( status === 'failed' ) return `${ $shm_theme.error }`
			return `${ $mol_theme.shade }`
		}

		tg_send_upload_visible() {
			const file = this.widget().File()?.remote()
			if( file?.Tg_file_id()?.val() ) return []
			if( this.tg_send_process()?.data().status === 'running' ) return []

			return super.tg_send_upload_visible()
		}

		@ $mol_action
		tg_send_upload() {
			const file = this.widget().File()?.remote()
			if( !file ) return

			const blob = file.blob()
			if( !blob ) throw new Error( 'Файл не найден' )

			const upload = new File(
				[ blob ],
				this.file_name(),
				{ type: blob.type },
			)

			return $mol_wire_async( file ).tg_send_file( upload )
		}

		@ $mol_mem
		baza_upload_progress() {
			const file = this.widget().File()?.remote()
			if( !file ) return null

			return file.baza_upload_progress()
		}

		baza_upload_progress_status() {
			const file = this.widget().File()?.remote()

			const progress = this.baza_upload_progress()
			if( !progress ) return 'Ожидание отправки'
			if( !progress.active ) return 'Отправлено'

			return `Отправка ${ Math.floor( progress.ratio * 100 ) }%`
		}

		baza_upload_progress_width() {
			const progress = this.baza_upload_progress()
			return `${ Math.floor( ( progress?.ratio ?? 0 ) * 100 ) }%`
		}

		baza_upload_progress_color() {
			return this.baza_upload_progress()?.active ? `${ $shm_theme.active }` : `${ $shm_theme.success }`
		}

		baza_upload_progress_visible() {
			const file = this.widget().File()?.remote()
			if( !file ) return []
			if( file.baza_download_progress() ) return []
			
			const created_at = this.widget().created_at()
			if( created_at == null ) {
				return super.baza_upload_progress_visible()
			}
			
			if( this.$.$mol_state_time.now( 1000 ) - created_at <= 10_000 ) return super.baza_upload_progress_visible()
			if( file.baza_upload_progress_peek() ) return super.baza_upload_progress_visible()
			return []
		}

		@ $mol_mem
		baza_download_progress() {
			const file = this.widget().File()?.remote()
			if( !file ) return null

			return file.baza_download_progress()
		}

		baza_download_progress_status() {
			const progress = this.baza_download_progress()
			if( !progress ) return ''

			return `Загрузка... ${ Math.floor( progress.ratio * 100 ) }%`
		}

		baza_download_progress_width() {
			const progress = this.baza_download_progress()
			return `${ Math.floor( ( progress?.ratio ?? 0 ) * 100 ) }%`
		}

		baza_download_progress_color() {
			return `${ $shm_theme.active }`
		}

		baza_download_progress_visible() {
			return this.baza_download_progress() ? super.baza_download_progress_visible() : []
		}

		@ $mol_action
		download() {
			const file = this.widget().File()?.remote()
			if( !file ) return

			const blob = file.blob()
			if( !blob ) throw new Error( 'Файл не найден' )

			const uri = $mol_wire_sync(this.$).$mol_blob_uri( blob )
			const link = this.$.$mol_dom_context.document.createElement( 'a' )
			link.href = uri
			link.download = this.file_name()
			link.click()
		}

		@ $mol_action
		unpacking() {
			const pos = this.Map_page().get_pointer_pos()

			const widget = this.map().widget_add( 'code_sql', pos, 800, 400 )
			const js = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_table_from_sql_result.js' ) )
			widget?.text( js )
			widget?.code_sql().sql( 'SELECT * FROM $'+`value('${this.widget().link().toString()!}')` )

			this.Map_page().contextmenu_showed( false )
		}

		unpacking_embed_code() {
			const ref = this.widget().link().toString()!
			return [
				`map.import_js_file( $`+`file('${ ref }') )`,
				``,
				`return $`+`make( $.$`+`hitalama_ba, {`,
				`	//layout_rows: function (){ return [ this.Main() ] },`,
				`	app_id: ()=> this_widget.link_str(),`,
				`	file: ()=> $`+`file('KGX44k7s_by9pw8kJ_8M5ksaTh').blob(),`,
				`	style: { position: 'absolute' }, //без этого будет общий скролл на все панели`,
				`} )`,
			].join( '\n' )
		}

		@ $mol_action
		unpacking_embed() {
			const pos = this.Map_page().get_pointer_pos()
			const widget = this.map().widget_add( 'code_js', pos, 600, 470 )
			widget?.title( `Import: ${ this.file_name() }` )
			widget?.text( this.unpacking_embed_code() )

			this.Map_page().contextmenu_showed( false )
		}

		// unpacking_parquet() {
		// 	const pos = this.Map_page().get_pointer_pos()

		// 	const code = this.map().widget_add( 'code', pos, 1000, 400 )
		// 	const code_str = this.$.$mol_fetch.text( $shm_hitalama_app_ghpages_fix_link( '/shm/hitalama/map/snippets/_table_from_parquet.js' ) )
		// 		.replaceAll( 'WIDGET_ID', `'${ this.widget().link().toString()! }'` )
		// 	code?.Text(null)?.value( code_str )

		// 	this.Map_page().contextmenu_showed( false )
		// }
		
	}
}
